export const SET_CONTACT = "SET_CONTACT";
